import React, { ReactElement } from 'react';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import { scaleImage } from '../../utils/scaleImage';

export interface ImageField {
  src?: string;
  alt?: string;
  height?: string;
  width?: string;
  loading?: string;
}

interface LazyLoadingProps {
  field: { value: ImageField };
  cssClass?: string;
  id?: string;
}

const LazyLoading: (props: LazyLoadingProps) => ReactElement = (props) => {
  if(typeof window != 'undefined'){
    let newProps = JSON.parse(JSON.stringify(props));
    newProps.field.value.src = scaleImage(
      props.field.value.src,
      window.innerWidth,
      1
    );
    props = newProps;
  }
  return (
    <div
      className={props.cssClass && props.cssClass}
      style={{ width: '100%', height: '100%' }}
    >
      <Image
        key={props.field?.value && props.field?.value?.alt}
        field={{ ...props.field }}
        loading={'lazy'}
      />
    </div>
  );
};

export default LazyLoading;
